<ap-panel class="shadow mt-2 align-items-stretch h-100">
  <div class="d-flex justify-content-start py-2 ps-2 bg-white">
    <div class="row p-2">
      <h4>
        {{ 'dashboard.taxImpactMap.title' | translate }}
      </h4>
    </div>
  </div>
  <div
    class="d-flex justify-content-start ps-3 pb-3 bg-white align-items-center">
    <ap-dropdown
      gstarDropDownAppkitOverlayListFix
      [list]="transactionTypeItems()"
      [title]="'portfolio.filterTransactionType' | translate"
      selectType="single"
      [disabled]="isNotClientSelected()"
      [ngModel]="chartService.selectedTransactionType()">
      @for (item of transactionTypeItems(); track $index) {
        <ap-dropdown-list-item
          [item]="item"
          (onSelectItem)="onSelectTransactionType($event)" />
      }
    </ap-dropdown>

    <ap-dropdown
      gstarDropDownAppkitOverlayListFix
      class="mx-2"
      [list]="taxResultTypeItems()"
      [title]="'dashboard.taxResultTypeFilter' | translate"
      selectType="single"
      [disabled]="isNotClientSelected()"
      [ngModel]="chartService.selectedTaxResultTypeType()">
      @for (item of taxResultTypeItems(); track $index) {
        <ap-dropdown-list-item
          #dropdownListItem
          [item]="item"
          (onSelectItem)="onSelectRateType($event)" />
      }
    </ap-dropdown>
  </div>
  @if (isNotClientSelected()) {
    <div class="d-flex ps-3 bg-white">
      <p>
        {{ 'dashboard.taxImpactMap.suggestionMessage' | translate }}
      </p>
    </div>
  }
  <gstar-tax-impact-map />
</ap-panel>
